<template>
  <div>
    <h3>投放数据查询</h3>
    <el-form :inline="true" size="mini">
      <el-form-item>
        <el-button
          type="primary"
          @click="$router.push('/talentActivity/edit')"
          size="mini"
          >新建</el-button
        >
      </el-form-item>
      <el-form-item label="广告标题">
        <el-input placeholder="广告标题" v-model="filter.title"></el-input>
      </el-form-item>
      <el-form-item label="投放状态">
        <el-select v-model="filter.status" placeholder="请选择投放状态">
          <el-option label="全部" :value="null"></el-option>
          <el-option label="待上线" :value="1"></el-option>
          <el-option label="已上线" :value="2"></el-option>
          <el-option label="已下线" :value="3"></el-option>
          <el-option label="已关闭" :value="4"></el-option>

        </el-select>
      </el-form-item>
      <el-form-item label="目标身份">
        <el-select v-model="filter.role" placeholder="请选择目标身份">
          <el-option label="全部" :value="null"></el-option>
          <el-option v-for="(label, key) in map.ad.role" :key="key" :label="label" :value="Number(key)"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="目标设备">
        <el-select v-model="filter.targetDevices" placeholder="请选择目标设备">
          <el-option label="全部" :value="null"></el-option>
          <el-option v-for="(label, key) in map.ad.targetDevices" :key="key" :label="label" :value="Number(key)"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="广告位页面">
        <el-select v-model="filter.type" placeholder="请选择广告位页面">
          <el-option label="全部" :value="null"></el-option>
          <el-option v-for="(label, key) in map.ad.pageType" :key="key" :label="label" :value="Number(key)"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="投放开始时间">
        <el-date-picker
          v-model="filter.putStartTime"
          type="datetime"
          placeholder="投放开始时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="投放结束时间">
        <el-date-picker
          v-model="filter.putEndTime"
          type="datetime"
          placeholder="投放结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="用户ID">
        <el-input placeholder="用户ID" v-model.number="filter.userId"></el-input>
      </el-form-item>
      <!-- <el-form-item label="创建人">
        <el-input
          placeholder="请输入创建人"
          v-model="filter.createOpt"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="投放创建时间">
        <el-date-picker
          v-model="filter.startTime"
          type="datetime"
          placeholder="开始时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="到">
        <el-date-picker
          v-model="filter.endTime"
          type="datetime"
          placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" size="mini" @click="fetch()">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini" v-loading="loading">
      <el-table-column prop="title" label="广告标题">
        <template slot-scope="scope"
          ><a :href="scope.row.url" target="_blank">{{
            scope.row.title
          }}</a></template
        >
      </el-table-column>
      <el-table-column prop="status" label="投放状态">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 1">待上线</div>
          <div v-if="scope.row.status == 2">已上线</div>
          <div v-if="scope.row.status == 3">已下线</div>
          <div v-if="scope.row.status == 4">已关闭</div>
        </template>
      </el-table-column>
      <el-table-column prop="days" label="投放时长(小时)">
        <template slot-scope="scope">
          {{ scope.row.days != null ? Number(scope.row.days) * 24 + ' 小时' : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="impressions" label="广告展示次数"></el-table-column>
      <el-table-column prop="role" label="目标身份">
        <template slot-scope="scope">{{ map.ad.role[scope.row.role] }}</template>
      </el-table-column>
      <el-table-column prop="role" label="目标设备">
        <template slot-scope="scope">{{ map.ad.targetDevices[scope.row.targetDevices] }}</template>
      </el-table-column>
      <el-table-column prop="id" label="广告投放ID"></el-table-column>
      <el-table-column prop="type" label="广告位页面">
        <template slot-scope="scope">{{ map.ad.pageType[scope.row.type] }}</template>
      </el-table-column>
      <el-table-column prop="startTime" label="投放开始时间" width="150"></el-table-column>
      <el-table-column prop="endTime" label="投放结束时间" width="150"></el-table-column>
      <el-table-column prop="userId" label="用户ID"></el-table-column>
      <el-table-column prop="url" label="跳转地址" width="300"></el-table-column>
      <el-table-column prop="createTime" label="投放创建时间" width="150"></el-table-column>
      <el-table-column prop="updateTime" label="最后修改时间" width="150"></el-table-column>
      <el-table-column prop="createOpt" label="创建人昵称"></el-table-column>
      <el-table-column label="查询数据" width="100">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="showStatistics(scope.row)">查询数据</el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-dropdown v-if="scope.row.status != 4" size="medium" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-menu" style="font-size: 24px"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="">
                <a
                  :href="`/talentActivity/edit?id=${scope.row.id}`"
                  target="_blank"
                  >修改</a
                >
              </el-dropdown-item>
              <el-dropdown-item :command="{ action: 'del', data: scope.row }"
                >删除</el-dropdown-item
              >
              <el-dropdown-item :command="{ action: 'up', data: scope.row }"
                >上线</el-dropdown-item
              >
              <el-dropdown-item :command="{ action: 'down', data: scope.row }"
                >下线</el-dropdown-item
              >
              <el-dropdown-item :command="{ action: 'stop', data: scope.row }"
                >终止投放</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="投放数据"
      :visible.sync="statisticsVisible"
      width="760px"
    >
      <el-form :inline="true" size="mini">
        <el-form-item label="开始时间">
          <el-date-picker
            v-model="statisticsFilter.startTime"
            type="datetime"
            placeholder="开始时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-date-picker
            v-model="statisticsFilter.endTime"
            type="datetime"
            placeholder="结束时间"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchStatistics">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="statisticsList" size="mini" v-loading="statisticsLoading">
        <el-table-column prop="name" label="用户类型" width="120"></el-table-column>
        <el-table-column prop="expPv" label="曝光PV" width="140"></el-table-column>
        <el-table-column prop="expUv" label="曝光UV" width="140"></el-table-column>
        <el-table-column prop="clkPv" label="点击PV" width="140"></el-table-column>
        <el-table-column prop="clkUv" label="点击UV" width="140"></el-table-column>
      </el-table>
    </el-dialog>
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="20"
        @current-change="(i) => (page = i)"
        :page-count="page"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import map from "../../datamap";
import api from "../api";
const { talentActivity } = api;

export default {
  name: "talentActivity",
  data() {
    return {
      map,
      loading: true,
      total: 0,
      page: 1,
      limit: 20,
      list: [],
      currentStatisticsRow: null,
      statisticsVisible: false,
      statisticsLoading: false,
      statisticsData: {},
      statisticsFilter: {
        startTime: "",
        endTime: "",
      },
      filter: {
        role: "",
        targetDevices:"",
        userId: "",
        type:"",
        userId:null
      },
    };
  },
  components: {},
  computed: {
    statisticsList() {
      let data = this.statisticsData || {};
      return [
        {
          name: "匿名用户",
          expPv: data.anonExpPv || 0,
          expUv: data.anonExpUv || 0,
          clkPv: data.anonClkPv || 0,
          clkUv: data.anonClkUv || 0,
        },
        {
          name: "登录用户",
          expPv: data.loginExpPv || 0,
          expUv: data.loginExpUv || 0,
          clkPv: data.loginClkPv || 0,
          clkUv: data.loginClkUv || 0,
        },
      ];
    },
  },
  watch: {
    page() {
      this.fetch();
    },
  },
  methods: {
    async fetch() {
      this.loading = true;
      var data = this.filter;
      data.limit = this.limit;
      data.pageNum = this.page;
      let res = await talentActivity.list(data);
      this.list = res.data.data;
      this.total = res.data.pageinfo.totalCount;
      this.loading = false;
    },

    showStatistics(row) {
      this.currentStatisticsRow = row;
      this.statisticsData = {};
      this.statisticsFilter = {
        startTime: "",
        endTime: "",
      };
      this.statisticsVisible = true;
      this.fetchStatistics();
    },

    async fetchStatistics() {
      if (!this.currentStatisticsRow) {
        return false;
      }
      this.statisticsLoading = true;
      let params = {
        adId: this.currentStatisticsRow.id,
        startTime: this.statisticsFilter.startTime,
        endTime: this.statisticsFilter.endTime,
      };
      let {
        data: { code, data },
      } = await talentActivity.statistics(params);
      if (code == 200) {
        this.statisticsData = data || {};
      }
      this.statisticsLoading = false;
    },

    async submit(obj, status) {
      obj.status = status;
      let {
        data: { code, data },
      } = await talentActivity.update(obj);
      let vue = this;
      if (code == 200) {
        this.$message({
          showClose: false,
          message: "保存成功",
          type: "success",
        });
        this.fetch();
      }
    },

    handleCommand(command) {
      let action = command.action;
      let data = command.data;
      switch (action) {
        case "del":
          this.delActivity(data);
          break;
        case "up":
          this.submit(data, 2);
          break;
        case "down":
          this.submit(data, 3);
          break;
        case "stop":
          this.submit(data, 4);
          break;
        default:
      }
    },
    delActivity(activityData) {
      this.$confirm("删除活动后不可恢复", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "再想想",
        type: "warning",
      })
        .then(() => {
          return this.$confirm("请再次确认是否删除该投放？", "二次确认", {
            confirmButtonText: "确认删除",
            cancelButtonText: "取消",
            type: "warning",
          });
        })
        .then(async () => {
          if (this.isSubmiting) return false;
          this.isSubmiting = true;
          let {
            data: { code, data },
          } = await talentActivity.delete({ id: activityData.id });
          if (code == 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.fetch();
          }
          this.isSubmiting = false;
        })
        .catch((e) => {
          console.log(e);
          this.isSubmiting = false;
          if (e === "cancel") {
            this.$message({
              type: "info",
              message: "已取消",
            });
          } else {
            this.$message({
              type: "error",
              message: "操作失败",
            });
          }
        });
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/talentActivity/list.vue